import { motion, useReducedMotion } from 'motion/react';

import Ticker from 'components/common/Ticker';
import BonApetitLogo from 'images/familyHome/bon-appetit-logo.svg';
import HealthlineLogo from 'images/familyHome/healthline-logo.svg';
import RomperLogo from 'images/familyHome/romper-logo.svg';
import TasteOfHomeLogo from 'images/familyHome/taste-of-home-logo.svg';
import TheKitchnLogo from 'images/familyHome/the-kitchn-logo.svg';
import WiredLogo from 'images/familyHome/wired-logo.svg';

const PARENT_VARIANT = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.1,
    },
  },
};

const createSlideInVariants = prefersReducedMotion => ({
  hidden: { opacity: 0, y: prefersReducedMotion ? 0 : 100 },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.7,
      type: prefersReducedMotion ? 'tween' : 'spring',
    },
  },
});

const FeaturedIn = ({ data, billboardAnimationComplete, onFeaturedInAnimationComplete }) => {
  const { title, bonAppetit, romper, tasteOfHome, wired, theKitchn, healthline } = data;

  const prefersReducedMotion = useReducedMotion();
  const slideInVariants = createSlideInVariants(prefersReducedMotion);

  const logoImages = [
    { src: BonApetitLogo, alt: bonAppetit },
    { src: RomperLogo, alt: romper },
    { src: TasteOfHomeLogo, alt: tasteOfHome },
    { src: WiredLogo, alt: wired },
    { src: TheKitchnLogo, alt: theKitchn },
    { src: HealthlineLogo, alt: healthline },
  ];

  return (
    <section className="-mt-px bg-green-140 pb-10 bp2:pb-16 bp2:pt-10">
      <motion.div
        className="flex flex-col items-center"
        variants={PARENT_VARIANT}
        initial="hidden"
        whileInView={prefersReducedMotion || billboardAnimationComplete ? 'visible' : 'hidden'}
        viewport={{ once: true, amount: 0.3 }}
        onAnimationComplete={definition => {
          if (definition === 'visible') {
            onFeaturedInAnimationComplete();
          }
        }}
      >
        <motion.h3
          className="textMd bp2:h5 mb-8 uppercase text-white-110"
          variants={slideInVariants}
        >
          {title}
        </motion.h3>
        <motion.div className="w-full" variants={slideInVariants}>
          <Ticker
            images={logoImages}
            containerClassName="mx-auto flex flex-row h-10 bp2:h-16"
            imageWrapperClassName="flex h-10 bp2:h-16 flex-shrink-0 items-center px-5 bp2:px-10"
          />
        </motion.div>
      </motion.div>
    </section>
  );
};

FeaturedIn.propTypes = {
  data: PropTypes.shape({
    title: PropTypes.string.isRequired,
    bonAppetit: PropTypes.string.isRequired,
    romper: PropTypes.string.isRequired,
    tasteOfHome: PropTypes.string.isRequired,
    wired: PropTypes.string.isRequired,
    theKitchn: PropTypes.string.isRequired,
    healthline: PropTypes.string.isRequired,
  }).isRequired,
  billboardAnimationComplete: PropTypes.bool.isRequired,
  onFeaturedInAnimationComplete: PropTypes.func.isRequired,
};

export default FeaturedIn;
